import { makeAutoObservable } from 'mobx'

export class UIStore {
  showPaymentsTable: boolean = false

  viewRefillPopup: boolean = false

  mute: boolean = true

  volume: number = 0

  showVolumePopup: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  partialUpdate = (data: Partial<UIStore>): void => {
    Object.assign(this, data)
  }

  togglePaymentsTable = (): void => {
    this.showPaymentsTable = !this.showPaymentsTable
  }

  setVolume = (value: number): void => {
    this.volume = value
    this.mute = value === 0
  }

  toggleMute = (): void => {
    this.mute = !this.mute
    this.volume = this.mute ? 0 : 1
  }

  setShowVolumePopup = (show: boolean): void => {
    this.showVolumePopup = show
  }
}
